import React from 'react';
import Shortcuts from '../platformui/Shortcuts/index';

export default (props) => (
    <Shortcuts {...props}> </Shortcuts>
);
